import * as React from "react"
const Cheese = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#F1CA3F"
      d="M4 27V12.806h24v3.549a3.666 3.666 0 0 0-.885 5.162L28 22.742V27H4Z"
    />
    <path
      fill="#FFEA9F"
      d="M4 12.806h24L11.385 5c-2.052.237-6.4 2.129-7.385 7.806Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 12.806V27h24v-4.258l-.885-1.225A3.666 3.666 0 0 1 28 16.355v0-3.549m-24 0h24m-24 0C4.985 7.13 9.333 5.236 11.385 5L28 12.806"
    />
    <circle
      cx={11}
      cy={19}
      r={3}
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <circle
      cx={20.5}
      cy={21.5}
      r={1.5}
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <circle
      cx={12.5}
      cy={9.5}
      r={0.5}
      fill="#010101"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
)
export default Cheese
